// Action Types
export const GROUP_LOADED_FROM_DB = 'group/groupLoadedFromDb';
export const GROUP_ADDED_LOCALLY = 'group/groupAddedLocally';
export const GROUP_CREATED_SUCCESS = 'group/groupCreatedSuccess';
export const GROUP_SYNC_FAILED = 'group/groupSyncFailed';
export const GROUP_PATCH_LOCAL = 'group/groupPatchLocal';
export const GROUP_CLEARED = 'group/groupCleared';

// Initial state: No group exists yet for the user.
const initialState = null;

export function group(state = initialState, action) {
  switch (action.type) {
    case GROUP_LOADED_FROM_DB:
      // When the user's single group is loaded from IndexedDB on app startup.
      return action.payload || null;

    case GROUP_ADDED_LOCALLY:
      // A new group was created offline. This becomes the *current* group in the state.
      return {
        ...action.payload,
        syncStatus: 'pending'
      };
    case GROUP_PATCH_LOCAL:
      return {
        ...state,
        ...action.payload,
        error: null,
        syncStatus: 'pending'
      }
    case GROUP_CREATED_SUCCESS:
      // The locally created group has successfully synced.
      // The payload contains the final server data and the original tempId.
      // We check if the synced group matches the one in the state.
      if (state && state.cacheId === action.payload.tempId) {
        return {
          ...action.payload, // This is the full group object from the server
          syncStatus: 'synced',
          error: null,
        };
      }
      // If the ID doesn't match, it might be a stale update, so we ignore it.
      return state;

    case GROUP_SYNC_FAILED:
      // A group's synchronization failed.
      // The payload contains the tempId and the error message.
      if (state && state.cacheId === action.payload.tempId) {
        return {
          ...state,
          syncStatus: 'error',
          error: action.payload.error,
        };
      }
      return state;
    case GROUP_CLEARED:
      return null;

    default:
      return state;
  }
}
